export const SET_PARAMETROS_BUSQUEDA = 'SET_PARAMETROS_BUSQUEDA';
export const SET_LIMPIAR_PARAMETROS = 'SET_LIMPIAR_PARAMETROS';

export const setLimpiarParametros = () => {
    return {
        type: SET_LIMPIAR_PARAMETROS
    }
};

export const setParametrosBusqueda = (data) => {
    return {
        type: SET_PARAMETROS_BUSQUEDA,
        payload: data
    }
};